import { bus } from "@/main";
import router from "@/router";

export default {
	data() {
		return{
			language: this.$route.params.lang,
			notificationActive: false,
			response: null,
		}
	},
	props: [],
	watch: {
		"$route": function () {
			this.language = this.$route.params.lang;
		}
	},
	created() {
		// this.bodyScroll()
		bus.$on("notification", (response) => {
			this.notificationActive = true;
			this.response = response;
			setTimeout(() => {
				this.notificationActive = false;
			}, 3000);
		});
	},
	methods: {
		bodyScroll(remove) {
			if (remove)
				document.querySelector("body").classList.remove("no--scroll")
			else
				document.querySelector("body").classList.add("no--scroll")
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/blocks/notification-block/notification.block.js